<div class="modal-container">
  <form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
    <section mat-dialog-title>
      <button mat-dialog-close mat-icon-button matTooltip="Close.">
        <mat-icon>close</mat-icon>
      </button>
      <h1 class="modalTitle">
        <mat-icon class="iconPosition"
          >{{ ProductInfo && 'edit' || 'add' }}</mat-icon
          >
          {{ ProductInfo && 'Edit' || 'Add' }} Extra Info
        </h1>
      </section>
      <section mat-dialog-content>
        <mat-form-field>
          <mat-label>Title</mat-label>
          <input formControlName="title" matInput />
        </mat-form-field>
        <quill-editor
          class="form-control"
          formControlName="description"
        ></quill-editor>
        @if (!ProductInfo.id) {
          <section>
            <label>Position</label>
            <mat-button-toggle-group
              (change)="setType($event.value)"
              [value]="form.controls['type'].value"
              >
              <mat-button-toggle value="payment">
                <mat-icon>vertical_align_top</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="product">
                <mat-icon>vertical_align_bottom</mat-icon>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </section>
        }
        <start-end-date-picker
          [FormGroup]="form"
          [endDate]="endDate"
          [startDate]="startDate"
        ></start-end-date-picker>

        <section class="gallery">
          <mat-checkbox
            (change)="showGallery($event.checked)"
            [checked]="galleryChecked"
            >Gallery</mat-checkbox
            >
            @if (galleryChecked) {
              <button
                type="button"
                mat-button
                (click)="addNewImage(thumbnails)"
                >
                Select Images
              </button>
            }
            @if (galleryChecked) {
              <section class="thumbnails">
                @for (thumbnail of thumbnails; track thumbnail) {
                  <section>
                    <img alt="image-thumbnail" [src]="getImageUrl(thumbnail)" />
                    <button (click)="removeGalleryFile(thumbnail)" mat-icon-button>
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </section>
                }
              </section>
            }
          </section>

          @if (!galleryChecked) {
            <section class="file-upload">
              @if (!form.controls['file_title'].value) {
                <button
                  (click)="addFile()"
                  mat-button
                  matTooltip="Add file."
                  type="button"
                  >
                  <mat-icon>file_upload</mat-icon>
                  Add File
                </button>
              }
              @if (selectedFiles?.length) {
                <div class="file-list">
                  @for (file of selectedFiles; track file; let i = $index) {
                    <div
                      class="file-item"
                      >
                      <div class="file-name">
                        @if (file.editing) {
                          <input
                            [(ngModel)]="file.tempTitle"
                            [ngModelOptions]="{ standalone: true }"
                            (keydown.enter)="disableEdit(i)"
                            (blur)="disableEdit(i)"
                            class="inline-input"
                            placeholder="Rename file"
                            />
                        } @else {
                          <span (dblclick)="enableEdit(i)" style="cursor: pointer">
                            {{ file.file_title_display || file.name }}
                          </span>
                        }
                      </div>
                      <div class="file-actions">
                        <button
                          mat-icon-button
                          type="button"
                          (click)="previewFileByIndex(i)"
                          matTooltip="View file"
                          >
                          <mat-icon>visibility</mat-icon>
                        </button>
                        <button
                          mat-icon-button
                          type="button"
                          (click)="removeFile(i)"
                          matTooltip="Remove file"
                          >
                          <mat-icon>delete</mat-icon>
                        </button>
                        @if (!file.editing) {
                          <button
                            mat-icon-button
                            (click)="enableEdit(i)"
                            matTooltip="Edit name"
                            type="button"
                            >
                            <mat-icon>edit</mat-icon>
                          </button>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </section>
          }
        </section>
        <section align="end" mat-dialog-actions>
          <button
            mat-button
            mat-dialog-close
            matTooltip="Cancel and close."
            type="button"
            >
            <mat-icon>cancel</mat-icon>
            Cancel
          </button>
          <button
            [disabled]="!form.valid || loading"
            mat-button
            matTooltip="Save product info."
            type="submit"
            >
            <mat-icon>save</mat-icon>
            Save
          </button>
        </section>
      </form>
      @if (loading) {
        <div class="loading-overlay">
          <div class="spinner-wrapper">
            <mat-spinner diameter="50"></mat-spinner>
            @if (uploadProgress >= 0 && uploadProgress < 100) {
              <div
                class="progress-text"
                >
                Uploading... {{ uploadProgress }}%
              </div>
            }
          </div>
        </div>
      }
    </div>
